/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useEffect } from 'react';
//import cmsUtils from '../../cms/utils/cmsUtils';
import utils from '../../utils';
//import style from './style';
import { useAuth } from '../../auth/index'
import { useRouter, SiteLink } from 'components';
import { LoginU } from 'components/customAuth/controls/login/loginU';

export function UnifiedLogin(props){
    const item = props.item || {}; // Provide default empty object
    const cmsOption = props.cmsOption || {};
    const cssClass = utils.classNames('cms_item', 'login', item.cssClass || item.anchorName || '');
    const _useAusth = useAuth();
    const router = useRouter();
    
    // Get return URL from query params
    const getReturnUrl = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const returnTo = urlParams.get('returnTo');
        return returnTo || null;
    };

    // Check if user is already logged in and redirect them
    useEffect(() => {
        const session = _useAusth.sessionV2 || _useAusth.session || _useAusth.user;
        
        if (session && !session.expired?.()) {
            // User is logged in, determine where to redirect
            const userMemberType = session?.memberType;
            const userRoles = session?.roles || [];
            const hasDashboardAccess = userMemberType || (Array.isArray(userRoles) && userRoles.length > 0);
            
            const returnUrl = getReturnUrl();
            
            if (returnUrl) {
                // Redirect back to the page they were trying to access
                router.push(returnUrl);
            } else if (hasDashboardAccess) {
                // Default to dashboard if they have access
                router.push('/dashboard');
            } else {
                // Default to homepage if no dashboard access
                router.push('/');
            }
        }
    }, [_useAusth.sessionV2, _useAusth.session, _useAusth.user, router]);
    
    return(
        <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
            {
                cmsOption.isCmsEdit ?
                <pre style={{fontSize: '12px', margin:'5px', padding: '10px', background:'#eee', border: '1px solid #ccc'}}>
                    <b> Unified Login Item </b>
                </pre> :
                <div>
                    <LoginU />
                    <div style={{maxWidth:'600px',margin:'auto',marginTop:'1rem'}}>
                        <SiteLink to = '/auth/forgot-password'>
                            Forgot Password?
                        </SiteLink>
                    </div>
                </div>
            }
        </div>
    )
}